import axios from 'axios';
import {
  GET_DISCOUNTS_REQUEST,
  GET_DISCOUNTS_SUCCESS,
  GET_DISCOUNTS_FAIL,
  CREATE_DISCOUNT_REQUEST,
  CREATE_DISCOUNT_SUCCESS,
  CREATE_DISCOUNT_FAIL,
  UPDATE_DISCOUNT_REQUEST,
  UPDATE_DISCOUNT_SUCCESS,
  UPDATE_DISCOUNT_FAIL,
  DELETE_DISCOUNT_REQUEST,
  DELETE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_FAIL,
  baseURL
} from "./types";

// Utility: Get token from localStorage
const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  const directToken = localStorage.getItem('token');
  return loginData.token || directToken || '';
};

// Get auth headers configuration
const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };
};

// Get All Discounts
export const getAllDiscounts = () => async (dispatch) => {
  try {
    dispatch({ type: GET_DISCOUNTS_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.post(
      `${baseURL}/api/appointmentAdminSetDiscount/getall`,
      {}, // Empty body
      config
    );

    console.log('Discounts API Response:', data);

    // Direct extraction based on your API structure {success: 1, data: [...]}
    const discountsArray = data.success === 1 ? data.data : [];

    dispatch({
      type: GET_DISCOUNTS_SUCCESS,
      payload: discountsArray,
    });
    return Promise.resolve(discountsArray);

  } catch (error) {
    console.error('Error fetching discounts:', error);
    dispatch({
      type: GET_DISCOUNTS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};

// Create Discount
export const createDiscount = (discountData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_DISCOUNT_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.post(
      `${baseURL}/api/appointmentAdminSetDiscount/create`,
      discountData,
      config
    );

    dispatch({
      type: CREATE_DISCOUNT_SUCCESS,
      payload: data.newDiscount || data.data || data,
    });
    return Promise.resolve(data);

  } catch (error) {
    dispatch({
      type: CREATE_DISCOUNT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};

// Update Discount
export const updateDiscount = (discountData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_DISCOUNT_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.patch(
      `${baseURL}/api/appointmentAdminSetDiscount/update`,
      discountData,
      config
    );

    dispatch({
      type: UPDATE_DISCOUNT_SUCCESS,
      payload: data.updatedDiscount || data.data || data,
    });
    return Promise.resolve(data);

  } catch (error) {
    dispatch({
      type: UPDATE_DISCOUNT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};

// Delete Discount
export const deleteDiscount = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_DISCOUNT_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.delete(
      `${baseURL}/api/appointmentAdminSetDiscount/delete`,
      {
        ...config,
        data: { id }
      }
    );

    dispatch({
      type: DELETE_DISCOUNT_SUCCESS,
      payload: id,
    });
    return Promise.resolve(data);

  } catch (error) {
    dispatch({
      type: DELETE_DISCOUNT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};